import { LinkItem } from '@occc-app/design-system';
import { readableDate } from '@occc-app/lib/format';
import { DateTimeFormat } from '@occc-app/lib/date';

import { routeCreator } from '../../messaging-center.utils';
import {
  PAGE_TITLE as BASE_PAGE_TITLE,
  CAMPAIGN_LIST_PAGE_TITLE,
} from '../../messaging-center.constants';

export const getBreadcrumbLinks = (name: string | undefined): LinkItem[] => [
  { to: routeCreator.base(), label: BASE_PAGE_TITLE },
  { to: routeCreator.campaignsList(), label: CAMPAIGN_LIST_PAGE_TITLE },
  { label: name || 'Loading...' },
];

export const localizeNumber = (n: number): string => {
  return n.toLocaleString();
};

export const getScheduledDateLabel = (scheduledDate?: string | null) => {
  if (!scheduledDate) return null;

  return readableDate(scheduledDate, DateTimeFormat.DateWithYear);
};

export const getScheduledTimeLabel = (scheduledDate?: string | null) => {
  if (!scheduledDate) return null;

  return `${readableDate(scheduledDate, DateTimeFormat.Time12h)} (Local Time)`;
};
